import * as React from 'react';
import { Star as StarIcon, StarBorder as StarBorderIcon } from '@material-ui/icons';
import { withStyles } from '@material-ui/core';

const MAX_RATING = 5;

const styles = (theme: any) => ({
  ratingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px'
  },
  starIcon: {
    color: theme.gridTextColor,
    fontSize: theme.headerTextFontSize24
  }
});

interface RatingRendererProps {
  value: number;
  data: any;
  classes: any;
}

const RatingRenderer = ({ value, classes }: RatingRendererProps) => {
  if (!value || value < 0) {
    return <div>-</div>;
  }

  return (
    <div className={classes.ratingContainer}>
      {Array.from({ length: MAX_RATING }, (_, i) => (
        <span key={i} className={classes.starIcon}>
          {i < value ? <StarIcon /> : <StarBorderIcon />}
        </span>
      ))}
    </div>
  );
};

export default withStyles(styles)(RatingRenderer);
